export default "__VITE_ASSET__BDSm$IvM__"